import { BaseContextSetup, NoAdsDetector } from '@platforms/shared';
import { context, InstantConfigService, utils } from '@wikia/ad-engine';
import { Injectable } from '@wikia/dependency-injection';
import { UcpMobileStickyTLBExperiment } from './../../experiments/ucp-mobile-sticky-tlb-experiment';

@Injectable()
export class UcpMobileBaseContextSetup extends BaseContextSetup {
	constructor(
		private ucpMobileStickyTLBExperiment: UcpMobileStickyTLBExperiment,
		protected instantConfig: InstantConfigService,
		protected noAdsDetector: NoAdsDetector,
	) {
		super(instantConfig, noAdsDetector);
	}

	execute(): void {
		super.execute();

		context.set('custom.serverPrefix', utils.isProperCountry(['AU', 'NZ']) ? 'vm1b' : 'wka1b');
		context.set(
			'options.disableStickyTopLeaderboard',
			this.instantConfig.get('icDisableStickyTopLeaderboard'),
		);
		context.set(
			'options.lazyLoadBottomLeaderboard',
			this.instantConfig.get('icLazyLoadBottomLeaderboard', false),
		);

		context.set(
			'options.removeOpenWebAddICB',
			this.instantConfig.get('icRemoveOpenWebAddICB', false),
		);

		if (
			!context.get('options.disableStickyTopLeaderboard') &&
			!context.get('custom.hasFeaturedVideo')
		) {
			this.setupStickyTlbExperiment();
		}
	}

	private setupStickyTlbExperiment(): void {
		context.set('templates.stickyTlb.experiment', this.ucpMobileStickyTLBExperiment.isTlbSticky());
	}
}
